import { ButtonHTMLAttributes } from "react";
import Link from "next/link";
import clsx from "clsx";
import styles from "./Button.module.scss";

export type ButtonProps = {
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  variant?: 'outlined' | 'filled' | 'secondary' | 'outlined-mini';
  size?: 'md' | 'sm';
  icon?: React.ReactNode;
  type?: 'button' | 'link';
  href?: string;
  style?: ButtonHTMLAttributes<HTMLButtonElement>['style'];
  children: React.ReactNode;
  action?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}


function Button(props: ButtonProps) {
  const { onClick, loading, disabled, variant = 'outlined', size = 'md', icon, action, children, type = 'button', style, href } = props;
  
  return type === 'button' ? (
    <button className={clsx(styles[variant], styles[`size_${size}`])} type={action} style={style} onClick={onClick} disabled={loading || disabled}>
      {icon}
      {children}
    </button>
  ) : (
    <Link href={href || ''} className={clsx(styles[variant], styles[`size_${size}`])} style={style}>
      {icon}
      {children}
    </Link>
  );
};

export { Button };